import S from './styles.module.scss';
import { LoadingButton } from '@mui/lab';
import Button from '@mui/material/Button';
import { ReactNode } from 'react';

type CustomModalFooterProps = {
	cancelText: string;
	okText: string;
	onCancel(): void;
	onOk(): void;
	isLoading?: boolean;
	isOkDisabled?: boolean;
	isCancelDisabled?: boolean;
	aboveFooter?: ReactNode;
};

const CustomModalFooter = ({
	cancelText,
	okText,
	onCancel,
	onOk,
	isLoading,
	isOkDisabled,
	isCancelDisabled,
	aboveFooter,
}: CustomModalFooterProps) => {
	return (
		<div className={S.footerWrapper}>
			{aboveFooter && aboveFooter}
			<div className={S.footer}>
				{onCancel && (
					<Button
						className={S.button__cancel}
						data-testid="cancelButton"
						color="primary"
						variant="contained"
						onClick={onCancel}
						disabled={isCancelDisabled}
					>
						{cancelText}
					</Button>
				)}

				<LoadingButton
					data-testid="acceptButton"
					color="primary"
					variant="contained"
					onClick={onOk}
					disabled={isOkDisabled}
					loading={isLoading}
				>
					{okText}
				</LoadingButton>
			</div>
		</div>
	);
};

export default CustomModalFooter;
